import { ALL_ROLE_PERMISSIONS } from '../actions/suraRolePermissionsActions';

const initialState = {
  all_role_permissions : null
} // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case ALL_ROLE_PERMISSIONS:
      newState = { all_role_permissions: payload };
      return { ...state, ...newState };

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/suraRolePermissionsReducer.js